export default function UpDownIcon({width = 12, height = 12 ,className}) {
    return (
        <img
            src="/assets/icons/up-down.svg"
            width={width}
            height={height}
            alt="Up and down icon"
            className={ className }
        />
    );
}